var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLuggageIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "24px",
    viewBox: "0 -960 960 960",
    width: "24px",
    fill: "#1f1f1f",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M306.5-177q-23.97 0-40.73-16.77Q249-210.53 249-234.5v-408q0-23.97 16.77-40.73Q282.53-700 306.5-700h88v-65.52q0-23.98 16.77-40.73Q428.03-823 452-823h56q23.97 0 40.73 16.77 16.77 16.76 16.77 40.73v65.5h88q23.97 0 40.73 16.77Q711-666.47 711-642.5v408q0 23.97-16.77 40.73Q677.47-177 653.5-177v13q0 11-8 19t-18.75 8Q616-137 608-145t-8-19v-13H360v13q0 11-8 19t-18.75 8q-10.75 0-18.75-8t-8-19v-13Zm0-25.5h347q14 0 23-9t9-23v-408q0-14-9-23t-23-9h-347q-14 0-23 9t-9 23v408q0 14 9 23t23 9Zm88-82.5H420v-307h-25.5v307Zm145.5 0h25.5v-307H540v307ZM420-700h120v-65.5q0-14-9-23t-23-9h-56q-14 0-23 9t-9 23v65.5Zm60 261.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLuggageIcon);
export default __webpack_public_path__ + "static/media/LuggageIcon.6873bfd3ebdd7f9734c0e4dd2133bb6a.svg";
export { ForwardRef as ReactComponent };